// @vendors
const React = require('react');
const PropTypes = require('prop-types');

const BrokerExanteProfitabilityCostsItem = require('components/commons/brokerExanteProfitabilityCostsItem/brokerExanteProfitabilityCostsItem');


class BrokerExanteProfitabilityCostsSubSection extends React.Component {
    buildKey(key) {
        const { context } = this.props;
        return `${context}-${key}`
    }

    buildDetails() {
        const {
            section,
            context,
            sectionTitle,
            eventCategory,
            complexTooltip,
        } = this.props;
        if (!!section.get('details')) {
            return section.get('details').map((detail, index) => (
                <BrokerExanteProfitabilityCostsItem
                    data={detail}
                    context={context}
                    key={index}
                    sectionTitle={sectionTitle}
                    eventCategory={eventCategory}
                    complexTooltip={complexTooltip}
                />
            ));
        }
    }

    render() {
        const {
            section,
            context,
            sectionTitle,
            eventCategory,
            complexTooltip,
        } = this.props;
        return (
            <div>
                <BrokerExanteProfitabilityCostsItem
                    data={section}
                    context={context}
                    sectionTitle={sectionTitle}
                    eventCategory={eventCategory}
                    complexTooltip={complexTooltip}
                />
                <div className="broker-ex-ant-cost__subsection-details">
                    {this.buildDetails()}
                </div>
            </div>
        );
    }
}

BrokerExanteProfitabilityCostsSubSection.propTypes = {
    section: PropTypes.object,
    context: PropTypes.string,
    sectionTitle: PropTypes.string,
    eventCategory: PropTypes.string,
    complexTooltip: PropTypes.bool,
}


module.exports = BrokerExanteProfitabilityCostsSubSection;
